export default __webpack_public_path__ + "static/media/gift-box.cacb6c76.gif";